"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workModeMap = {
    JSON_CTRL: 1,
    JSON_TRANSPARENT: 0,
    JSON_TRANSPARENT_NOT_CHECK_RAW: 4,
    TRANSPARENT: 2,
    TRANSPARENT48: 3
};
exports.default = (function (virtual) { return function () {
    var device = virtual.device;
    return {
        action: 'reportDevInfo',
        msgId: virtual.msgId,
        params: {
            binType: 'A',
            binVer: '0.0.0.0',
            devTid: device.devTid,
            mid: device.mid,
            SDKVer: '0.0.0.0',
            serviceHost: 'asia-dev.aihomi.com',
            servicePort: 184,
            SSID: 'HEKR-VD',
            tokenType: 2,
            workMode: workModeMap[device.workModeType]
        }
    };
}; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/reportDevInfo.ts